"use client";

import Image from "next/image";
import Link from "next/link";
import { useLanguage } from "@/lib/LanguageContext";

export const Logo = ({ showText = true }: { showText?: boolean }) => {
    const { language } = useLanguage();
    const isArabic = language === 'ar';

    return (
        <Link href={`/${language}`} className="flex items-center gap-2 group">
            {/* Light Mode Logo */}
            <Image
                src="/logo-light.png"
                alt="Ecommaps Logo"
                width={32}
                height={32}
                className="w-8 h-8 object-contain dark:hidden block"

            />
            {/* Dark Mode Logo */}
            <Image
                src="/logo-dark.png"
                alt="Ecommaps Logo"
                width={32}
                height={32}
                className="w-8 h-8 object-contain hidden dark:block"

            />
            {showText && (
                <span className="text-xl font-bold text-foreground tracking-tight">
                    {isArabic ? 'إيكومابس' : 'Ecommaps'}<span className="text-primary">.</span>
                </span>
            )}
        </Link>
    );
};

export default Logo;
